(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["2021-how-to-content"] && !Shopify.designMode) return;
  try {
    
(function ($) {
  const $scrolly = $("#howToScrolly");
  const headerOffset =
    document.getElementById("shopify-section-header-2021").offsetTop +
    $("#shopify-section-header-2021").height();
  const scrollyOffset = $scrolly.offset().top;

  document.addEventListener("scroll", function (e) {
    if ($(window).width() > 991) {
      // This is for when it enters the fixed place
      if (
        window.pageYOffset > scrollyOffset - headerOffset - 48 &&
        window.pageYOffset <
          $(".instruction-article").offset().top +
            $(".instruction-article").height() -
            $scrolly.height() -
            60
      ) {
        if (!$scrolly.hasClass("fixed-scrolly")) {
          $scrolly.css({
            top: headerOffset + "px",
            width: Math.round($scrolly.width()) + "px",
          });
          

          $scrolly.removeClass("bottom-scrolly");
          $scrolly.addClass("fixed-scrolly");
        }
      } else if (
        window.pageYOffset >
        $(".instruction-article").offset().top +
          $(".instruction-article").height() -
          $scrolly.height() -
          60
      ) {
        if (!$scrolly.hasClass("bottom-scrolly")) {
          $scrolly.removeClass("fixed-scrolly");
          $scrolly.addClass("bottom-scrolly");
        }
      } else {
        $scrolly.removeClass("fixed-scrolly");
        $scrolly.removeClass("bottom-scrolly");

        $scrolly.css({
          top: "",
          width: "",
        });
      }
    }
  });
})(jQuery);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-2021-contents"] && !Shopify.designMode) return;
  try {
    
$("a[href*='#collection']").on('click', function(e) {
  e.preventDefault();

  const linkHref = $(this).attr('href');

  if($(linkHref).length > 0) {
    console.log('Found O -60', linkHref);
    $('html,body').animate({
      scrollTop: $(linkHref).offset().top - 60
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grind-away-content"]) return;
  try {
    
console.log('Ready for Submissions.');
$('#grind-away-submission-form').submit(function(e) {
    e.preventDefault();

    const guess = $('#formQuestion').val()
    const email = $('#formEmail').val();
    const grindMarketing = $('#formGdprGrind').is(':checked') ? 'Yes' : 'No';
    const awayMarketing = $('#formGdprAway').is(':checked') ? 'Yes' : 'No';

    if(guess && email) {
        $.post('https://docs.google.com/forms/d/e/1FAIpQLSexmag0LcC09Em26DpitgGgPd0TDJ9ILfMlUncy4zjyyuw66g/formResponse', {
            'entry.1316406592': email,
            'entry.1567622691': guess,
            'entry.371070314': grindMarketing,
            'entry.436880255': awayMarketing
        }, function(data) {
            console.log('DATA: ', data);
        });
    }

    window.location.href = '/pages/grind-x-away-confirmation';
});

  } catch(e) { console.error(e); }
})();
})();
